import { useRouter } from 'next/navigation';

import { getProductsForCategory } from '@screens/Category';
import { CATEGORY_URL } from '@screens/Product/model/config/path';
import { ID_COLLECTION_ATTRIBUTE, ID_TYPE_PRODUCT_ATTRIBUTE } from '@shared/constants/keys';
import { ROUTES } from '@shared/constants/routes';
import { useAppSelector } from '@shared/hooks/redux';

export const useCharsManager = () => {
  const { push } = useRouter();
  const props = useAppSelector((state) => state.product.data.props);
  const category = props[ID_TYPE_PRODUCT_ATTRIBUTE]?.values?.[0]?.value ?? '';
  const limit = useAppSelector((state) => state.category.pagination.limit);
  const skip = useAppSelector((state) => state.category.pagination.skip);

  const onClickCollectionLink = async () => {
    if (!category) return;

    const { filtersHash } = await getProductsForCategory({
      category: category,
      params: {
        filters: {
          [ID_TYPE_PRODUCT_ATTRIBUTE]: [category],
          [ID_COLLECTION_ATTRIBUTE]: [props[ID_COLLECTION_ATTRIBUTE]?.values?.[0]?.value]
        },
        skip,
        limit,
        filtersHash: '',
        sort: 'asc'
      }
    });

    push(`${ROUTES.CATALOG}/${CATEGORY_URL[category]}?filtersHash=${filtersHash}`);
  };

  return { onClickCollectionLink, props };
};
